import { create } from 'zustand';

interface MqttState {
  isConnected: boolean;
  stationId: string;
  brokerUrl: string;
  lastError: string | null;
  reconnectAttempts: number;
  subscriptions: string[];

  setConnected: (isConnected: boolean) => void;
  setStationId: (stationId: string) => void;
  setBrokerUrl: (brokerUrl: string) => void;
  setLastError: (error: string | null) => void;
  setReconnectAttempts: (attempts: number) => void;
  addSubscription: (topic: string) => void;
  removeSubscription: (topic: string) => void;
  reset: () => void;
}

const initialState = {
  isConnected: false,
  stationId: '',
  brokerUrl: '',
  lastError: null as string | null,
  reconnectAttempts: 0,
  subscriptions: [] as string[]
};

export const useMqttStore = create<MqttState>()(set => ({
  ...initialState,

  setConnected: (isConnected: boolean) =>
    set({ isConnected, lastError: isConnected ? null : undefined }),

  setStationId: (stationId: string) => set({ stationId }),

  setBrokerUrl: (brokerUrl: string) => set({ brokerUrl }),

  setLastError: (error: string | null) => set({ lastError: error }),

  setReconnectAttempts: (attempts: number) =>
    set({ reconnectAttempts: attempts }),

  addSubscription: (topic: string) =>
    set(state => ({
      subscriptions: state.subscriptions.includes(topic)
        ? state.subscriptions
        : [...state.subscriptions, topic]
    })),

  removeSubscription: (topic: string) =>
    set(state => ({
      subscriptions: state.subscriptions.filter(t => t !== topic)
    })),

  reset: () => set(initialState)
}));
